const darkmode = () => {
  if (document.querySelector('.btn-mode') !== null) {
    const btn = document.querySelector('.btn-mode');
    const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
    const currentTheme = localStorage.getItem('theme');

    function themeDark(selectorBody) {
      if (selectorBody.classList.contains('dark-theme')) {
        selectorBody.classList.add('light-theme');
        selectorBody.classList.remove('dark-theme');
        var theme = 'light';
      } else {
        selectorBody.classList.add('dark-theme');
        selectorBody.classList.remove('light-theme');
        var theme = 'dark';
      }
      localStorage.setItem('theme', theme);
    }

    if (prefersDarkScheme.matches || currentTheme === 'dark') {
      document.body.classList.add('dark-theme');

      if (document.querySelector('switch') !== null) {
        document.querySelector('switch').classList.add('dark-theme');
      }
      var theme = 'dark';
    } else {
      document.body.classList.add('light-theme');

      if (document.querySelector('switch') !== null) {
        document.querySelector('switch').classList.add('light-theme');
      }
      var theme = 'light';
    }

    localStorage.setItem('theme', theme);

    btn.addEventListener('click', function () {
      themeDark(document.body);

      if (document.querySelector('switch') !== null) {
        themeDark(document.querySelector('switch'));
      }
    });
  }
};

export { darkmode };
